import { useQueryParams } from "../../hooks";
import { Container, PaymentDetailsContainer } from "./styled";
import { Button } from "..";
import { useHistory } from "react-router-dom";

export const PaymentResultBox = () => {
  const query = useQueryParams();
  const isSuccessfull = query.get("status") === "True";
  const history = useHistory();

  return (
    <Container>
      <h1>
        {isSuccessfull ? "پرداخت با موفقیت انجام شد" : "پرداخت انجام نشد"}
      </h1>
      <PaymentDetailsContainer>
        <div className="item">
          <h3>شناسه پرداخت:</h3>
          <p>{query.get("invoiceId")}</p>
        </div>
      </PaymentDetailsContainer>
      <Button
        onClick={() => {
          history.push("/subscriptions");
        }}
        color="blue"
      >
        رفتن به لیست اشتراکات
      </Button>
    </Container>
  );
};
